/**
 * productTypeKeys - a mapping object associating product type keys with their corresponding full names and descriptions.
 * @example 
 * const productTypeKeys = {
  C: 'Concrete',
  T: 'Thinshell',
  G: 'GFRC'
};
productTypeKeys['C']; //Output:'Concrete'
 * 
 */

const productTypeKeys = {
  C: 'Concrete',
  T: 'Thinshell',
  G: 'GFRC'
};

export default productTypeKeys;
